jQuery(function($){
  if ($('.aid-form__form').length){

    var ecotravo = [35711, 47688, 57349, 69233, 81646];
    var anah = [20805, 30427, 36591, 42748, 48930];

    $('.aid-form__form').on('submit', function(e){
      _paq.push(['trackEvent', 'formulaire', 'formulaire-aides', 'formulaire-aides-OK']);

      $('.aid-form').removeClass('eligible-audit eligible-anah eligible-ecotravo eligibile-anah-audit');
      e.preventDefault();
      var $form = $(this);
      var nb = parseInt($form.find('input[name="nb-people"]').val());
      var income = parseInt($form.find('input[name="income"]').val());
      if (nb > 0 && income > 0){
        var anah_ceiling = anah[Math.min(nb-1, anah.length-1)];
        if (nb > anah.length){
          anah_ceiling = anah[anah.length-1] + (nb - anah.length) * 6165;
        }
        var ecotravo_ceiling = ecotravo[Math.min(nb-1, ecotravo.length-1)];
        if(income <= anah_ceiling){
          $('.aid-form').addClass('eligible-anah');
        }
        else if(income <= ecotravo_ceiling){
          $('.aid-form').addClass('eligible-ecotravo');
        }
        else{
          $('.aid-form').addClass('eligible-anah-audit');
        }
        $('.aid-form').addClass('eligible-audit');
      }

    });

    $('.aid-form-copro-js').on('click', function(e){
      e.preventDefault();
      if ($(this).hasClass('small-copro-js')){
        $('.aid-form').removeClass('eligible-large-copro').addClass('eligible-small-copro');
      }
      else{
        $('.aid-form').removeClass('eligible-small-copro').addClass('eligible-large-copro');
      }
    });
  }
});
